
  // Get the current date
  var currentDate = new Date();

  // Add 5 days to the current date
  var deliveryDate = new Date(currentDate.getTime() + (5 * 24 * 60 * 60 * 1000));

  // Format the delivery date as desired (e.g., "D MMMM")
  var formattedDeliveryDate = deliveryDate.getDate() + ' ' + getMonthName(deliveryDate.getMonth());

  // Update the contents of the div element with the delivery date
  document.querySelector('#delivery-date .expected_delivery_date').textContent = formattedDeliveryDate;

  // Function to get the month name based on the month index
  function getMonthName(monthIndex) {
    var monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];

    return monthNames[monthIndex];
  }



document.querySelectorAll('.mit-accordion-header').forEach(header => {

    header.addEventListener('click', function(){

        const accordion = this.parentElement;

        accordion.classList.toggle('active');

    });

});




/* Fresh template gallery behavior. */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.mit-fresh-product').forEach(function (root) {
    var main = root.querySelector('.mit-fresh-gallery__image');
    root.querySelectorAll('.mit-fresh-gallery__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!main || !thumb.dataset.imageUrl) return;
        main.src = thumb.dataset.imageUrl;
        root.querySelectorAll('.mit-fresh-gallery__thumb').forEach(function (item) {
          item.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      });
    });
  });
});


document.addEventListener('shopify:section:load', function (event) {
  event.target.querySelectorAll('.mit-accordion-header').forEach(function (header) {
    if (header.dataset.mitBound === 'true') return;
    header.dataset.mitBound = 'true';
    header.addEventListener('click', function () {
      this.parentElement.classList.toggle('active');
    });
  });
});
